import {
  DATA_REQUEST_ASYNC,
  FORM_RESET,
  GROUP_TOGGLE,
  PAGINATE_CHANGE,
  SEARCH_CHANGE,
  SEARCH_RESET,
  SELECT_ALL,
  SET_INTEGRATION_TYPE,
  SHARED_MAILBOXES_CHANGE,
  SUBMIT_CUSTOMIZED_AUTO_SYNC_ASYNC,
  SYNC_ALL_UPDATE,
  UNSELECT_ALL,
} from './constants'

const fetchData = (integrationType) => ({
  type: DATA_REQUEST_ASYNC.INITIATE,
  payload: { integrationType },
})
export const fetchDataSuccess = (data) => ({
  type: DATA_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchDataError = (error) => ({
  type: DATA_REQUEST_ASYNC.ERROR,
  error,
})

const submitCustomizedSync = (data) => ({
  type: SUBMIT_CUSTOMIZED_AUTO_SYNC_ASYNC.INITIATE,
  payload: { data },
})
export const submitCustomizedSyncSuccess = () => ({
  type: SUBMIT_CUSTOMIZED_AUTO_SYNC_ASYNC.SUCCESS,
})
export const submitCustomizedSyncError = (error) => ({
  type: SUBMIT_CUSTOMIZED_AUTO_SYNC_ASYNC.ERROR,
  error,
})

const setIntegrationType = (val) => ({
  type: SET_INTEGRATION_TYPE,
  payload: { val },
})
const searchChange = (q) => ({ type: SEARCH_CHANGE, payload: { q } })
const searchReset = () => ({ type: SEARCH_RESET })

const handleSyncAll = () => ({ type: SYNC_ALL_UPDATE })
const toggleGroup = (group) => ({ type: GROUP_TOGGLE, payload: { group } })

const sharedMailboxesChange = () => ({ type: SHARED_MAILBOXES_CHANGE })

const selectAll = () => ({ type: SELECT_ALL })
const unselectAll = () => ({ type: UNSELECT_ALL })

const paginateChange = (page) => ({ type: PAGINATE_CHANGE, payload: { page } })

const resetForm = () => ({ type: FORM_RESET })

export default {
  // to props
  fetchData,
  submitCustomizedSync,
  setIntegrationType,
  searchChange,
  searchReset,
  handleSyncAll,
  toggleGroup,
  sharedMailboxesChange,
  selectAll,
  unselectAll,
  paginateChange,
  resetForm,
}
